import React, { useState, useEffect, useCallback } from "react";
import { toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../assets/styles/Adminwebsubscriptionmonthly.css"
import LeftNav from "../components/common/LeftNav";
import TopNav from "../components/common/TopNav";
import editIcon from "../assets/img/editadminweb.svg";
import deleteIcon from "../assets/img/deleteadminweb.svg";
import arrowleftt from "../assets/img/arrowleftt.svg"
import close from "../assets/img/close-square.svg";
import billingService from "../../services/billingService";

export default function ManageSubscriptions() {
  const navigate = useNavigate();

  // Main state
  const [loading, setLoading] = useState(true);
  const [subscriptionPlans, setSubscriptionPlans] = useState([]);
  const [creditPackages, setCreditPackages] = useState([]);
  const [masterCreditPrice, setMasterCreditPrice] = useState(2.0);

  // Filter state
  const [billingCycle, setBillingCycle] = useState("monthly");
  const [userType, setUserType] = useState("agent");

  // Modal states
  const [showAddPlanModal, setShowAddPlanModal] = useState(false);
  const [showEditPlanModal, setShowEditPlanModal] = useState(false);
  const [showEditFreePlanModal, setShowEditFreePlanModal] = useState(false);
  const [showAddCreditModal, setShowAddCreditModal] = useState(false);
  const [showEditCreditModal, setShowEditCreditModal] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);

  // Selected items
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [selectedCreditPackage, setSelectedCreditPackage] = useState(null);
  const [planToDelete, setPlanToDelete] = useState(null);
  const [packageToDelete, setPackageToDelete] = useState(null);

  // Form state for adding/editing plans - matching AdminTask.js exactly
  const [pkgName, setPkgName] = useState('');
  const [pkgFeature, setPkgFeature] = useState('');
  const [originalPrice, setOriginalPrice] = useState('');
  const [offerPrice, setOfferPrice] = useState('');
  const [subFeatures, setSubFeatures] = useState([]);
  const [subFeaturesList, setSubFeaturesList] = useState([{ name: '', is_included: true }]); // Advanced features like mobile app
  const [newSubFeature, setNewSubFeature] = useState('');
  const [status, setStatus] = useState('Active');
  const [planLabel, setPlanLabel] = useState('');
  const [saveUpTo, setSaveUpTo] = useState('');
  const [planUserType, setPlanUserType] = useState('agent');
  const [planPeriod, setPlanPeriod] = useState('monthly');
  const [packageType, setPackageType] = useState('subscription_package'); // subscription_package or user_package like mobile app
  const [freeCredits, setFreeCredits] = useState(''); // Free credits for builders

  // Edit modal state (matching mobile app exactly)
  const [editPkgName, setEditPkgName] = useState('');
  const [editPkgFeature, setEditPkgFeature] = useState('');
  const [editSubFeatures, setEditSubFeatures] = useState([]); // Advanced features for edit
  const [editNewSubFeature, setEditNewSubFeature] = useState('');
  const [editStatus, setEditStatus] = useState('Active');
  const [editOriginalPrice, setEditOriginalPrice] = useState('');
  const [editOfferPrice, setEditOfferPrice] = useState('');
  const [editSaveUpTo, setEditSaveUpTo] = useState('');
  const [editPlanLabel, setEditPlanLabel] = useState('');
  const [editingPlanId, setEditingPlanId] = useState(null);
  const [isEditingPremium, setIsEditingPremium] = useState(false);
  const [editFreeCredits, setEditFreeCredits] = useState('');

  // Form state for adding/editing credit packages
  const [creditAmount, setCreditAmount] = useState('');
  const [creditDescription, setCreditDescription] = useState('');
  const [creditPrice, setCreditPrice] = useState('');
  const [creditStatus, setCreditStatus] = useState('active');

  // GST functions matching mobile app AdminManageSubscription.js exactly
  const GST_RATE = 0.18;
  const fmtINR = (n) => (parseFloat(n) || 0).toLocaleString('en-IN', { maximumFractionDigits: 0 });
  const gstCalc = (p) => { const v = parseFloat(p) || 0; const g = Math.round(v * GST_RATE); return { gst: g, total: v + g }; };

  // Data loading functions
  const loadSubscriptionPlans = useCallback(async () => {
    try {
      setLoading(true);
      const filters = {};

      if (userType && userType !== '' && userType !== 'all') {
        filters.user_type = userType;
      }

      if (billingCycle) {
        filters.period = billingCycle;
      }

      console.log('🔍 Loading subscription plans with filters:', filters);
      const response = await billingService.getSubscriptionPlans(filters);
      console.log('📡 Raw API response:', response);
      console.log('📦 Response data:', response.data);
      console.log('📋 Plans array:', response.data?.plans);

      if (response.success && response.data && response.data.plans) {
        const transformedPlans = response.data.plans.map(plan => {
          // Parse sub_features properly - could be array, JSON string, or undefined
          let subFeaturesArray = [];
          try {
            if (Array.isArray(plan.sub_features)) {
              subFeaturesArray = plan.sub_features;
            } else if (typeof plan.sub_features === 'string') {
              // Try to parse as JSON string
              subFeaturesArray = JSON.parse(plan.sub_features);
              if (!Array.isArray(subFeaturesArray)) {
                subFeaturesArray = [];
              }
            } else if (plan.sub_features) {
              // If it's an object or other type, try to convert
              subFeaturesArray = [plan.sub_features];
            }
          } catch (e) {
            console.warn('Failed to parse sub_features for plan:', plan.id, e);
            subFeaturesArray = [];
          }

          console.log('🔧 Plan:', plan.package_name, 'Sub-features:', subFeaturesArray);

          return {
            id: plan.id,
            name: plan.package_name || plan.name,
            description: plan.description || '',
            price: (plan.offer_price && parseFloat(plan.offer_price) > 0) ? `₹ ${parseFloat(plan.offer_price).toLocaleString('en-IN')}` : 'Free',
            originalPrice: plan.original_price ? `₹ ${parseFloat(plan.original_price).toLocaleString('en-IN')}` : '',
            offerPrice: plan.offer_price ? `₹ ${parseFloat(plan.offer_price).toLocaleString('en-IN')}` : '',
            status: plan.status || 'active',
            features: subFeaturesArray,
            sub_features: subFeaturesArray,
            popular: plan.plan_label === 'Most Popular' || plan.plan_label === 'Popular',
            plan_label: plan.plan_label || '',
            save_upto: plan.save_upto || '',
            user_type: plan.user_type,
            package_type: plan.package_type,
            period: plan.period,
            max_properties: plan.max_properties,
            max_leads: plan.max_leads,
            max_team_members: plan.max_team_members,
            free_credits: plan.free_credits,
            isFree: !plan.offer_price || parseFloat(plan.offer_price) === 0,
            active: plan.status === 'active'
          };
        });

        console.log('✅ Loaded plans:', transformedPlans.length, 'for period:', billingCycle);
        console.log('📊 Transformed plans:', transformedPlans);
        setSubscriptionPlans(transformedPlans);
      } else {
        console.warn('❌ No plans found from API. Response structure:', {
          success: response.success,
          hasData: !!response.data,
          hasPlans: !!(response.data && response.data.plans),
          dataStructure: response.data ? Object.keys(response.data) : 'No data'
        });
        setSubscriptionPlans([]);
      }
    } catch (err) {
      console.error('Error loading subscription plans:', err);
      setSubscriptionPlans([]);
    } finally {
      setLoading(false);
    }
  }, [userType, billingCycle]);

  const loadCreditPackages = useCallback(async () => {
    try {
      console.log('💳 Loading credit packages...');
      const response = await billingService.getCreditPackages({});
      console.log('💳 Credit packages API response:', response);
      console.log('💳 Credit packages data:', response.data);
      console.log('💳 Packages array:', response.data?.packages);

      if (response.success && response.data && response.data.packages) {
        const transformedPackages = response.data.packages.map(pkg => ({
          id: pkg.id,
          title: `${parseInt(pkg.credits).toLocaleString('en-IN')} Credits`,
          desc: pkg.description || '',
          price: `₹${parseFloat(pkg.price).toLocaleString('en-IN')}`,
          credits: pkg.credits,
          priceRaw: pkg.price,
          status: pkg.status,
          active: pkg.status === 'active'
        }));

        console.log('✅ Loaded credit packages:', transformedPackages.length);
        console.log('💳 Transformed packages:', transformedPackages);
        setCreditPackages(transformedPackages);
      } else {
        console.warn('❌ No credit packages found from API. Response structure:', {
          success: response.success,
          hasData: !!response.data,
          hasPackages: !!(response.data && response.data.packages),
          dataStructure: response.data ? Object.keys(response.data) : 'No data'
        });
        setCreditPackages([]);
      }
    } catch (err) {
      console.error('Error loading credit packages:', err);
      setCreditPackages([]);
    }
  }, []);

  // Auto-calculate Save Upto for Add Modal (matching mobile app exactly)
  useEffect(() => {
    const origStr = String(originalPrice || '').replace(/,/g, '');
    const offerStr = String(offerPrice || '').replace(/,/g, '');
    const orig = parseFloat(origStr || '0');
    let offer = parseFloat(offerStr || '0');

    // If offer price is not given, take it as original amount
    if (!offerStr) {
      offer = orig;
    }

    if (orig > offer && offer > 0) {
      const discount = ((orig - offer) / orig) * 100;
      setSaveUpTo(`${discount.toFixed(2)}%`);
    } else {
      setSaveUpTo('');
    }
  }, [originalPrice, offerPrice]);

  // Auto-calculate Save Upto for Edit Modal (matching mobile app exactly)
  useEffect(() => {
    const origStr = String(editOriginalPrice || '').replace(/,/g, '');
    const offerStr = String(editOfferPrice || '').replace(/,/g, '');
    const orig = parseFloat(origStr || '0');
    let offer = parseFloat(offerStr || '0');

    // If offer price is not given, take it as original amount
    if (!offerStr) {
      offer = orig;
    }

    if (orig > offer && offer > 0) {
      const discount = ((orig - offer) / orig) * 100;
      setEditSaveUpTo(`${discount.toFixed(2)}%`);
    } else {
      setEditSaveUpTo('');
    }
  }, [editOriginalPrice, editOfferPrice]);

  // Free plan always has zero original price (builders don't have a free plan)
  useEffect(() => {
    if (planUserType === 'builder' && planPeriod === 'free') {
      setPlanPeriod('monthly');
    } else if (planPeriod === 'free') {
      setOriginalPrice('0');
    }
  }, [planUserType, planPeriod]);

  // Update pkgName default based on userType and packageType (like mobile app)
  useEffect(() => {
    if (packageType === 'user_package') {
      if (planUserType === 'builder') {
        setPkgName('City Manager');
      } else if (planUserType === 'agency') {
        setPkgName('Agency Manager');
      }
    } else {
      setPkgName('');
    }
  }, [planUserType, packageType]);

  // Load data on component mount and when filters change
  useEffect(() => {
    loadSubscriptionPlans();
  }, [loadSubscriptionPlans]);

  useEffect(() => {
    loadCreditPackages();
  }, [loadCreditPackages]);

  // CRUD Operations
  const createSubscriptionPlan = async () => {
    try {
      const origStr = String(originalPrice || '').replace(/,/g, '');
      const offerStr = String(offerPrice || '').replace(/,/g, '');
      const orig = parseFloat(origStr || '0');
      let priceVal = parseFloat(offerStr || '0');

      if (!offerStr) {
        priceVal = orig;
      }

      let finalName = pkgName;
      if (priceVal === 0 && packageType === 'subscription_package') {
        finalName = 'Free Package';
      }

      let calculatedSaveUpto = saveUpTo;
      if (orig > priceVal && priceVal > 0) {
        const discount = ((orig - priceVal) / orig) * 100;
        calculatedSaveUpto = `${discount.toFixed(2)}%`;
      }

      const planData = {
        user_type: planUserType,
        package_type: packageType,
        free_credits: parseInt(freeCredits || '0', 10),
        package_name: finalName,
        name: finalName,
        period: planPeriod,
        description: pkgFeature,
        original_price: planPeriod === 'free' ? 0 : orig,
        offer_price: priceVal,
        price: priceVal,
        save_upto: calculatedSaveUpto,
        plan_label: planLabel,
        sub_features: subFeaturesList.filter(f => f.name.trim()),
        status: status,
      };

      console.log('Creating subscription plan with data:', planData);
      const response = await billingService.createSubscriptionPlan(planData);

      if (response.success) {
        console.log('✓ Plan created successfully');
        clearPlanForm();
        setShowAddPlanModal(false);
        await loadSubscriptionPlans();
        toast.success('Plan created successfully!');
      } else {
        console.error('❌ Plan creation failed:', response.message);
        toast.error(response.message || 'Failed to create plan');
      }
    } catch (error) {
      console.error('❌ Error creating plan:', error);
      toast.error('Error creating plan. Please try again.');
    }
  };

  const updateSubscriptionPlan = async () => {
    if (!editingPlanId) return;

    try {
      // Use edit states instead of create states (matching mobile app exactly)
      const planData = {
        package_name: editPkgName,
        description: editPkgFeature,
        original_price: parseFloat(editOriginalPrice) || 0,
        offer_price: parseFloat(editOfferPrice) || 0,
        sub_features: editSubFeatures.filter(f => f.name.trim()), // Advanced features with is_included
        status: editStatus.toLowerCase(),
        plan_label: editPlanLabel,
        save_upto: editSaveUpTo,
        user_type: selectedPlan?.user_type || 'agent',
        period: selectedPlan?.period || 'monthly',
        free_credits: parseInt(editFreeCredits || '0', 10),
      };

      console.log('Updating subscription plan with data:', planData);
      const response = await billingService.updateSubscriptionPlan(editingPlanId, planData);

      if (response.success) {
        console.log('✓ Plan updated successfully');
        clearEditForm();
        setShowEditPlanModal(false);
        setShowEditFreePlanModal(false);
        await loadSubscriptionPlans();
        toast.success('Plan updated successfully!');
      } else {
        console.error('❌ Plan update failed:', response.message);
        toast.error(response.message || 'Failed to update plan');
      }
    } catch (error) {
      console.error('❌ Error updating plan:', error);
      toast.error('Error updating plan. Please try again.');
    }
  };

  // Clear edit form function (matching mobile app)
  const clearEditForm = () => {
    setEditPkgName('');
    setEditPkgFeature('');
    setEditSubFeatures([]);
    setEditNewSubFeature('');
    setEditStatus('Active');
    setEditOriginalPrice('');
    setEditOfferPrice('');
    setEditSaveUpTo('');
    setEditPlanLabel('');
    setEditFreeCredits('');
    setEditingPlanId(null);
    setIsEditingPremium(false);
    setSelectedPlan(null);
  };

  const deleteSubscriptionPlan = async (planId) => {
    try {
      console.log('Deleting subscription plan:', planId);
      const response = await billingService.deleteSubscriptionPlan(planId);

      if (response.success) {
        console.log('✓ Plan deleted successfully');
        await loadSubscriptionPlans();
        toast.success('Plan deleted successfully!');
      } else {
        console.error('❌ Plan deletion failed:', response.message);
        toast.error(response.message || 'Failed to delete plan');
      }
    } catch (error) {
      console.error('❌ Error deleting plan:', error);
      toast.error('Error deleting plan. Please try again.');
    }
  };

  const createCreditPackage = async () => {
    try {
      const packageData = {
        credits: parseInt(creditAmount),
        description: creditDescription,
        price: parseFloat(creditPrice) || (parseInt(creditAmount) * masterCreditPrice),
        status: creditStatus
      };

      console.log('Creating credit package with data:', packageData);
      const response = await billingService.createCreditPackage(packageData);

      if (response.success) {
        console.log('✓ Credit package created successfully');
        clearCreditForm();
        setShowAddCreditModal(false);
        await loadCreditPackages();
        toast.success('Credit package created successfully!');
      } else {
        console.error('❌ Credit package creation failed:', response.message);
        toast.error(response.message || 'Failed to create credit package');
      }
    } catch (error) {
      console.error('❌ Error creating credit package:', error);
      toast.error('Error creating credit package. Please try again.');
    }
  };

  const updateCreditPackage = async () => {
    if (!selectedCreditPackage) return;

    try {
      const packageData = {
        credits: parseInt(creditAmount),
        description: creditDescription,
        price: parseFloat(creditPrice) || (parseInt(creditAmount) * masterCreditPrice),
        status: creditStatus
      };

      console.log('Updating credit package with data:', packageData);
      const response = await billingService.updateCreditPackage(selectedCreditPackage.id, packageData);

      if (response.success) {
        console.log('✓ Credit package updated successfully');
        clearCreditForm();
        setShowEditCreditModal(false);
        await loadCreditPackages();
        toast.success('Credit package updated successfully!');
      } else {
        console.error('❌ Credit package update failed:', response.message);
        toast.error(response.message || 'Failed to update credit package');
      }
    } catch (error) {
      console.error('❌ Error updating credit package:', error);
      toast.error('Error updating credit package. Please try again.');
    }
  };

  const deleteCreditPackage = async (packageId) => {
    try {
      console.log('Deleting credit package:', packageId);
      const response = await billingService.deleteCreditPackage(packageId);

      if (response.success) {
        console.log('✓ Credit package deleted successfully');
        await loadCreditPackages();
        toast.success('Credit package deleted successfully!');
      } else {
        console.error('❌ Credit package deletion failed:', response.message);
        toast.error(response.message || 'Failed to delete credit package');
      }
    } catch (error) {
      console.error('❌ Error deleting credit package:', error);
      toast.error('Error deleting credit package. Please try again.');
    }
  };

  // Form helpers
  const clearPlanForm = () => {
    setPkgName('');
    setPkgFeature('');
    setOriginalPrice('');
    setOfferPrice('');
    setSubFeatures([]);
    setSubFeaturesList([{ name: '', is_included: true }]);
    setNewSubFeature('');
    setStatus('Active');
    setPlanLabel('');
    setSaveUpTo('');
    setPlanUserType('agent');
    setPlanPeriod('monthly');
    setPackageType('subscription_package');
    setFreeCredits('');
    setSelectedPlan(null);
  };

  const clearCreditForm = () => {
    setCreditAmount('');
    setCreditDescription('');
    setCreditPrice('');
    setCreditStatus('active');
    setSelectedCreditPackage(null);
  };

  const populatePlanForm = (plan) => {
    setPkgName(plan.name || '');
    setPkgFeature(plan.description || '');
    setOriginalPrice(plan.originalPrice ? plan.originalPrice.replace(/[^0-9.]/g, '') : '');
    setOfferPrice(plan.offerPrice ? plan.offerPrice.replace(/[^0-9.]/g, '') : '');
    setSubFeatures(plan.features || []);
    setStatus(plan.status ? plan.status.charAt(0).toUpperCase() + plan.status.slice(1) : 'Active');
    setPlanLabel(plan.plan_label || '');
    setSaveUpTo(plan.save_upto || '');
    setPlanUserType(plan.user_type || 'agent');
    setPlanPeriod(plan.period || 'monthly');
  };

  const populateCreditForm = (pkg) => {
    setCreditAmount(pkg.credits ? pkg.credits.toString() : '');
    setCreditDescription(pkg.desc || '');
    setCreditPrice(pkg.priceRaw ? pkg.priceRaw.toString() : '');
    setCreditStatus(pkg.status || 'active');
  };

  // Event handlers - matching mobile app exactly
  const handleEditPlan = (plan) => {
    console.log('🔧 handleEditPlan called with plan:', plan);

    setEditingPlanId(plan.id);
    setEditPkgName(plan.name || '');
    setEditPkgFeature(plan.description || '');

    console.log('📝 Setting edit form data:', {
      id: plan.id,
      name: plan.name,
      description: plan.description,
      sub_features: plan.sub_features,
      originalPrice: plan.originalPrice,
      offerPrice: plan.offerPrice,
      status: plan.status,
      plan_label: plan.plan_label
    });

    // Map existing sub-features into the edit sub-features array like mobile app
    const feats = (plan.sub_features || []).map(f => ({
      name: typeof f === 'string' ? f : f.name || '',
      is_included: typeof f === 'object' ? (f.is_included !== undefined ? f.is_included : true) : true
    }));
    setEditSubFeatures(feats);
    console.log('🔧 Mapped sub-features for edit:', feats);

    const st = plan.status || 'Active';
    setEditStatus(st.charAt(0).toUpperCase() + st.slice(1).toLowerCase());
    setEditPlanLabel(plan.plan_label || '');

    // Handle pricing - extract numbers from formatted prices
    const originalPriceStr = plan.originalPrice ? plan.originalPrice.replace(/[₹,\s]/g, '') : '';
    const offerPriceStr = plan.offerPrice ? plan.offerPrice.replace(/[₹,\s]/g, '') : '';

    console.log('💰 Price processing:', {
      originalFormatted: plan.originalPrice,
      originalExtracted: originalPriceStr,
      offerFormatted: plan.offerPrice,
      offerExtracted: offerPriceStr
    });

    setEditOriginalPrice(originalPriceStr);
    setEditOfferPrice(offerPriceStr);
    setEditFreeCredits(plan.free_credits?.toString() || '');

    setSelectedPlan(plan);

    // Determine which modal based on free/premium price logic (like mobile app)
    if (plan.isFree || (!plan.offerPrice || plan.offerPrice === 'Free')) {
      setIsEditingPremium(false);
      setShowEditFreePlanModal(true); // Free modal
      console.log('🆓 Opening Free Plan edit modal');
    } else {
      setIsEditingPremium(true);
      setShowEditPlanModal(true); // Premium modal
      console.log('💎 Opening Premium Plan edit modal');
    }
  };

  const handleDeletePlan = (plan) => {
    setPlanToDelete(plan);
    setConfirmOpen(true);
  };

  const handleDeleteConfirmed = async () => {
    if (planToDelete) {
      await deleteSubscriptionPlan(planToDelete.id);
      setPlanToDelete(null);
    } else if (packageToDelete) {
      await deleteCreditPackage(packageToDelete.id);
      setPackageToDelete(null);
    }
    setConfirmOpen(false);
  };

  const handleEditCreditPackage = (pkg) => {
    setSelectedCreditPackage(pkg);
    populateCreditForm(pkg);
    setShowEditCreditModal(true);
  };

  const handleDeleteCreditPackage = (pkg) => {
    setPackageToDelete(pkg);
    setConfirmOpen(true);
  };

  const addSubFeature = () => {
    if (newSubFeature.trim()) {
      setSubFeatures([...subFeatures, newSubFeature.trim()]);
      setNewSubFeature('');
    } else {
      setSubFeatures([...subFeatures, '']);
    }
  };

  const removeSubFeature = (index) => {
    setSubFeatures(subFeatures.filter((_, i) => i !== index));
  };

  const updateSubFeature = (index, value) => {
    const newFeatures = [...subFeatures];
    newFeatures[index] = value;
    setSubFeatures(newFeatures);
  };

  // Edit sub-features handlers (matching mobile app exactly)
  const addEditSubFeature = () => {
    if (editNewSubFeature.trim()) {
      setEditSubFeatures([...editSubFeatures, { name: editNewSubFeature.trim(), is_included: true }]);
      setEditNewSubFeature('');
    } else {
      setEditSubFeatures([...editSubFeatures, { name: '', is_included: true }]);
    }
  };

  const removeEditSubFeature = (index) => {
    setEditSubFeatures(editSubFeatures.filter((_, i) => i !== index));
  };

  const updateEditSubFeature = (index, value) => {
    const newFeatures = [...editSubFeatures];
    newFeatures[index] = { ...newFeatures[index], name: value };
    setEditSubFeatures(newFeatures);
  };

  const toggleEditSubFeatureIncluded = (index) => {
    const newFeatures = [...editSubFeatures];
    newFeatures[index] = { ...newFeatures[index], is_included: !newFeatures[index].is_included };
    setEditSubFeatures(newFeatures);
  };

  // Filter change handlers
  const handleUserTypeChange = (newUserType) => {
    setUserType(newUserType);
  };

  const handleBillingCycleChange = (newCycle) => {
    setBillingCycle(newCycle);
  };

  return (
    <div className="ps-page d-flex">
      <LeftNav />

      <div className="ps-content-wrap flex-grow-1">
        <TopNav />

        <div className="container-fluid ps-outer">
          <div className="ps-container-card ">
            <div className="ps-card-body">
              <div className="d-flex align-items-center justify-content-between mb-4 ps-header-row">
                <div className="d-flex align-items-center gap-2">
                   <img src={arrowleftt} onClick={() => navigate("/adminprofile")} style={{cursor: "pointer"}} alt="Back"></img>
                  <h2 className="ps-title mb-0">Manage Subscriptions</h2>
                </div>
              </div>

              {/* Controls row */}
              <div className="d-flex align-items-center justify-content-between flex-wrap ps-controls-row">
                <div>
                  <div className="ps-user-type-label mb-2">User Type</div>
                  <div className="d-flex align-items-center gap-2 ps-user-type">
                    <label
                      className={`ps-chip ${userType === "agent" ? "ps-chip-active" : ""}`}
                      onClick={() => handleUserTypeChange("agent")}
                    >
                      <input type="checkbox" checked={userType === "agent"} readOnly />
                      <span>Agents</span>
                    </label>

                    <label
                      className={`ps-chip ${userType === "agency" ? "ps-chip-active" : ""}`}
                      onClick={() => handleUserTypeChange("agency")}
                    >
                      <input type="checkbox" checked={userType === "agency"} readOnly />
                      <span>Agency</span>
                    </label>

                    <label
                      className={`ps-chip ${userType === "builder" ? "ps-chip-active" : ""}`}
                      onClick={() => handleUserTypeChange("builder")}
                    >
                      <input type="checkbox" checked={userType === "builder"} readOnly />
                      <span>Builders</span>
                    </label>
                  </div>
                </div>

                <div className="ps-billing-wrapper">
                  <div className="ps-billing-toggle">
                    <button
                      className={`ps-toggle-btn ${billingCycle === "monthly" ? "active" : ""}`}
                      onClick={() => handleBillingCycleChange("monthly")}
                    >
                      Monthly
                    </button>
                    <button
                      className={`ps-toggle-btn ${billingCycle === "yearly" ? "active" : ""}`}
                      onClick={() => handleBillingCycleChange("yearly")}
                    >
                      Yearly
                    </button>
                  </div>
                </div>
              </div>

              {/* Plans grid */}
              <div className="ps-plans-row mt-4">

                {loading ? (
                  <div className="text-center py-5">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    <div className="mt-3" style={{ color: '#888' }}>Loading...</div>
                  </div>
                ) : subscriptionPlans.length === 0 ? (
                  <div className="text-center py-4">
                    <p>No subscription plans found for {userType} ({billingCycle})</p>
                    <p className="text-muted">Click "Add New Plan" to create your first plan.</p>
                  </div>
                ) : (
                  <div className="ps-plans-grid">
                    {subscriptionPlans.map((p) => (
                      <div className="ps-plan-card" key={p.id}>
                        <div className="ps-plan-header">
                          <div className="ps-plan-header-left">
                            <div className="ps-plan-title">{p.name}</div>
                            <div className="ps-plan-sub">{p.description}</div>
                          </div>
                          {p.active && <div className="ps-badge-active">● Active</div>}
                        </div>

                        <div className="ps-plan-body">
                          <div className="ps-plan-price-wrapper">
                            <div className="ps-plan-price-line">
                              {p.originalPrice && <span className="ps-original-price">{p.originalPrice}</span>}
                              <span className="ps-plan-price">
                                {p.price}
                                {p.period && !p.isFree && <span className="ps-period">/{billingCycle === 'yearly' ? 'Year' : 'Month'}</span>}
                              </span>
                            </div>
                            {!p.isFree && parseFloat(p.offerPrice.replace(/[₹,\s]/g, '')) > 0 && (
                              <div className="ps-gst-breakdown" style={{ fontSize: '11px', color: '#059669', marginTop: '4px', fontWeight: '600' }}>
                                + GST (18%): ₹{fmtINR(gstCalc(parseFloat(p.offerPrice.replace(/[₹,\s]/g, ''))).gst)} = ₹{fmtINR(gstCalc(parseFloat(p.offerPrice.replace(/[₹,\s]/g, ''))).total)}
                              </div>
                            )}
                          </div>
                          <ul className="ps-plan-features">
                            {p.features.map((f, idx) => (
                              <li key={idx} className="ps-feature">
                                {typeof f === 'string' ? f : f.name || ''}
                              </li>
                            ))}
                          </ul>
                          {p.plan_label && <div className="ps-plan-label">{p.plan_label}</div>}
                          {p.save_upto && <div className="ps-save-percent">Save {p.save_upto}</div>}
                        </div>

                        <div className="ps-plan-actions">
                          <button className="ps-btn-edit" onClick={() => handleEditPlan(p)}>Edit</button>
                          <button className="ps-btn-delete" onClick={() => handleDeletePlan(p)}>Delete</button>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
 {confirmOpen && (
        <div className="mu-modal-overlay" onClick={() => setConfirmOpen(false)}>
          <div className="mu-confirm-modal" onClick={(e) => e.stopPropagation()}>
            <div className="mu-confirm-icon">!</div>
            <h4 className="mu-confirm-title">Are you sure?</h4>
            <p className="mu-confirm-body">
              Are you sure you want to delete this {planToDelete ? 'subscription plan' : 'credit package'}? This action cannot be undone.
            </p>

            <div className="mu-confirm-actions">
              <button className="btn btn-light mu-confirm-cancel" onClick={() => {
                setConfirmOpen(false);
                setPlanToDelete(null);
                setPackageToDelete(null);
              }}>Cancel</button>
              <button className="btn btn-danger mu-confirm-delete" onClick={handleDeleteConfirmed}>Delete</button>
            </div>
          </div>
        </div>
      )}
                {/* Add New Plan Button */}
                <div style={{position: 'fixed', bottom: '20px', right: '20px', zIndex: 1000}}>
                  <button className="ps-add-plan-btn" onClick={() => {
                    clearPlanForm();
                    setPlanUserType(userType);
                    setPlanPeriod(billingCycle);
                    setShowAddPlanModal(true);
                  }}>
                    + Add New Plan
                  </button>
                </div>
              </div>


              {/* Push Notifications Credits section - Only show for builder user type */}
              {/* {userType === "builder" && (
                <div className="ps-credits-section mt-5">
                  <h5 className="ps-credits-title mb-4">Push Notifications Credits</h5>

                  {creditPackages.length === 0 ? (
                    <div className="text-center py-4">
                      <p>No credit packages found</p>
                      <p className="text-muted">Click "Add New Credit Package" to create your first package.</p>
                    </div>
                  ) : (
                    <div className="ps-credits-grid">
                      {creditPackages.map((c) => (
                        <div key={c.id} className="ps-credit-item">
                          <div className="ps-credit-info">
                            <div>
                              <div className="ps-credit-name">{c.title}</div>
                              <div className="ps-credit-desc">{c.desc}</div>
                            </div>
                            {c.active && <div className="ps-badge-active">● Active</div>}
                          </div>
                          <div className="ps-credit-bottom">
                            <div className="ps-credit-price">{c.price}</div>
                            <div className="ps-credit-actions">
                              <button className="ps-icon-btn" onClick={() => handleEditCreditPackage(c)}>
                                <img src={editIcon} alt="edit" />
                              </button>
                              <button className="ps-icon-btn ps-delete" onClick={() => handleDeleteCreditPackage(c)}>
                                <img src={deleteIcon} alt="delete" />
                              </button>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}

                  <div className="mt-4" style={{overflow: 'auto', display: 'flex', gap: '12px'}}>
                    <button className="ps-add-credit-btn" onClick={() => {
                      clearCreditForm();
                      setShowAddCreditModal(true);
                    }}>
                      Add New Credit Package
                    </button>
                  </div>
                </div>
              )} */}
            </div>
          </div>
        </div>
      </div>

      {/* Add New Plan Modal */}
      {showAddPlanModal && (
        <div className="sub-modal-overlay" onClick={() => setShowAddPlanModal(false)}>
          <div className="sub-modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="sub-modal-header">
              <h3 className="sub-modal-title">Add New Plan</h3>
              <button style={{border:"none",background:"#fff"}} onClick={() => { clearPlanForm(); setShowAddPlanModal(false); }}><img src={close} alt="Close" /></button>
            </div>
            <div className="sub-modal-body">

              {/* Billing Period */}
              <div className="sub-form-row">
                <div className="sub-form-group">
                  <label className="sub-form-label">User Type</label>
                  <select className="sub-form-control" value={planUserType} onChange={(e) => setPlanUserType(e.target.value)}>
                    <option value="agent">Agent</option>
                    <option value="agency">Agency</option>
                    <option value="builder">Builder</option>
                  </select>
                </div>
                <div className="sub-form-group">
                  <label className="sub-form-label">Billing Period</label>
                  <select className="sub-form-control" value={planPeriod} onChange={(e) => setPlanPeriod(e.target.value)}>
                    <option value="monthly">Monthly</option>
                    <option value="yearly">Yearly</option>
                    {/* Builders don't have a free plan */}
                    {planUserType !== 'builder' && <option value="free">Free</option>}
                  </select>
                </div>
              </div>

              {/* Package Type tabs (only for non-agent) */}
              {planUserType !== 'agent' && (
                <div className="sub-form-group">
                  <label className="sub-form-label">Package Type</label>
                  <div className="ps-billing-toggle" style={{ marginTop: '4px', display: 'flex', justifyContent: 'center', background: 'transparent' }}>
                    <button
                      type="button"
                      className={`ps-toggle-btn ${packageType === 'subscription_package' ? 'active' : ''}`}
                      onClick={() => setPackageType('subscription_package')}
                    >
                      Subscription Package
                    </button>
                    <button
                      type="button"
                      className={`ps-toggle-btn ${packageType === 'user_package' ? 'active' : ''}`}
                      onClick={() => setPackageType('user_package')}
                    >
                      User Package
                    </button>
                  </div>
                </div>
              )}

              {/* Package Name — Picker for user_package, else text input */}
              <div className="sub-form-group">
                <label className="sub-form-label">Package Name</label>
                {packageType === 'user_package' && planUserType !== 'agent' ? (
                  <select className="sub-form-control" value={pkgName} onChange={(e) => setPkgName(e.target.value)}>
                    {planUserType === 'builder' && <option value="City Manager">City Manager</option>}
                    {planUserType === 'builder' && <option value="Manager">Manager</option>}
                    {planUserType === 'builder' && <option value="Sub User">Sub User</option>}
                    {planUserType === 'agency' && <option value="Agency Manager">Agency Manager</option>}
                    {planUserType === 'agency' && <option value="Manager">Manager</option>}
                    {planUserType === 'agency' && <option value="Sub User">Sub User</option>}
                  </select>
                ) : (
                  <input
                    type="text"
                    className="sub-form-control"
                    placeholder="Enter Package Name"
                    value={pkgName}
                    onChange={(e) => setPkgName(e.target.value)}
                  />
                )}
              </div>

              {/* Free Credits — only for builder + subscription_package */}
              {planUserType === 'builder' && packageType === 'subscription_package' && (
                <div className="sub-form-group">
                  <label className="sub-form-label">Free Credits</label>
                  <input
                    type="number"
                    className="sub-form-control"
                    placeholder="E.g 100"
                    value={freeCredits}
                    onChange={(e) => setFreeCredits(e.target.value)}
                  />
                </div>
              )}

              {/* Package Feature */}
              <div className="sub-form-group">
                <label className="sub-form-label">Package Feature</label>
                <input
                  type="text"
                  className="sub-form-control"
                  placeholder="Enter Package Feature"
                  value={pkgFeature}
                  onChange={(e) => setPkgFeature(e.target.value)}
                />
              </div>

              {/* Original Price + Offer Price side by side */}
              <div className="sub-form-row">
                <div className="sub-form-group">
                  <label className="sub-form-label">Original Price</label>
                  <input
                    type="number"
                    className="sub-form-control"
                    placeholder="E.g 6999"
                    value={originalPrice}
                    onChange={(e) => setOriginalPrice(e.target.value)}
                    disabled={planPeriod === 'free'}
                  />
                </div>
                <div className="sub-form-group">
                  <label className="sub-form-label">Offer Price</label>
                  <input
                    type="number"
                    className="sub-form-control"
                    placeholder="E.g 4999"
                    value={offerPrice}
                    onChange={(e) => setOfferPrice(e.target.value)}
                  />
                </div>
              </div>

              {/* GST Preview */}
              {parseFloat(offerPrice) > 0 && (
                <div style={{ backgroundColor: '#ECFDF5', borderRadius: '8px', padding: '10px', marginBottom: '12px', textAlign: 'center' }}>
                  <div style={{ fontSize: '13px', color: '#059669', fontWeight: '600' }}>
                    Base: ₹{fmtINR(offerPrice)} + GST (18%): ₹{fmtINR(gstCalc(offerPrice).gst)} = Total: ₹{fmtINR(gstCalc(offerPrice).total)}
                  </div>
                </div>
              )}

              {/* Sub Features with tick/cross toggle */}
              <div className="sub-form-group">
                <label className="sub-form-label">Sub Features</label>
                {subFeaturesList.map((feat, index) => (
                  <div key={index} className="sub-feature-row" style={{ alignItems: 'center', marginBottom: '6px' }}>
                    <button
                      type="button"
                      onClick={() => {
                        const newList = [...subFeaturesList];
                        newList[index] = { ...newList[index], is_included: !newList[index].is_included };
                        setSubFeaturesList(newList);
                      }}
                      style={{ background: 'none', border: 'none', padding: '0 6px 0 0', cursor: 'pointer', fontSize: '20px', lineHeight: 1 }}
                    >
                      {feat.is_included
                        ? <span style={{ color: '#10B981' }}>✓</span>
                        : <span style={{ color: '#EF4444' }}>✗</span>}
                    </button>
                    <input
                      type="text"
                      className="sub-form-control"
                      value={feat.name}
                      onChange={(e) => {
                        const newList = [...subFeaturesList];
                        newList[index] = { ...newList[index], name: e.target.value };
                        setSubFeaturesList(newList);
                      }}
                      placeholder={`Feature ${index + 1}`}
                    />
                    <button
                      type="button"
                      className="sub-delete-feature-btn"
                      onClick={() => setSubFeaturesList(subFeaturesList.filter((_, i) => i !== index))}
                    >
                      <img src={deleteIcon} alt="delete" />
                    </button>
                  </div>
                ))}
                <button
                  type="button"
                  className="sub-add-feature-btn"
                  style={{ marginTop: '6px' }}
                  onClick={() => setSubFeaturesList([...subFeaturesList, { name: '', is_included: true }])}
                >
                  <span className="sub-plus-icon">+</span> Add Feature
                </button>
              </div>

              {/* Status */}
              <div className="sub-form-group">
                <label className="sub-form-label">Status</label>
                <select className="sub-form-control" value={status} onChange={(e) => setStatus(e.target.value)}>
                  <option value="Active">Active</option>
                  <option value="Inactive">Inactive</option>
                  <option value="Pending">Pending</option>
                </select>
              </div>

              {/* Plan Label */}
              <div className="sub-form-group">
                <label className="sub-form-label">Plan Label (Optional)</label>
                <input
                  type="text"
                  className="sub-form-control"
                  placeholder="e.g. Popular"
                  value={planLabel}
                  onChange={(e) => setPlanLabel(e.target.value)}
                />
              </div>

              {/* Save Up To (auto-calculated) */}
              <div className="sub-form-group">
                <label className="sub-form-label">Save up to (Optional)</label>
                <input
                  type="text"
                  className="sub-form-control"
                  placeholder="Auto-calculated if left blank"
                  value={saveUpTo}
                  readOnly
                />
              </div>

            </div>
            <div className="sub-modal-footer">
              <button className="sub-btn-secondary" onClick={() => {
                clearPlanForm();
                setShowAddPlanModal(false);
              }}>Cancel</button>
              <button className="sub-btn-primary" onClick={createSubscriptionPlan}>Create Plan</button>
            </div>
          </div>
        </div>
      )}

      {/* Edit Package Plan Modal - Fixed data binding */}
      {showEditPlanModal && (
        <div className="sub-modal-overlay" onClick={() => setShowEditPlanModal(false)}>
          <div className="sub-modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="sub-modal-header">
              <h3 className="sub-modal-title">Edit Plan</h3>
              <button style={{border:"none",background:"#fff"}} onClick={() => setShowEditPlanModal(false)}><img src={close} alt="Close" /></button>
            </div>
            <div className="sub-modal-body">
              <div className="sub-form-group">
                <label className="sub-form-label">Package Name</label>
                <input
                  type="text"
                  className="sub-form-control"
                  value={editPkgName}
                  onChange={(e) => setEditPkgName(e.target.value)}
                />
              </div>
              <div className="sub-form-row">
                <div className="sub-form-group">
                  <label className="sub-form-label">Package Description</label>
                  <input
                    type="text"
                    className="sub-form-control"
                    value={editPkgFeature}
                    onChange={(e) => setEditPkgFeature(e.target.value)}
                  />
                </div>
                <div className="sub-form-group">
                  <label className="sub-form-label">Offer Price</label>
                  <input
                    type="number"
                    className="sub-form-control"
                    value={editOfferPrice}
                    onChange={(e) => setEditOfferPrice(e.target.value)}
                  />
                  {parseFloat(editOfferPrice) > 0 && (
                    <div className="gst-preview" style={{ backgroundColor: '#ECFDF5', borderRadius: '8px', padding: '10px', marginTop: '8px', textAlign: 'center' }}>
                      <div style={{ fontSize: '13px', color: '#059669', fontWeight: '600' }}>
                        Base: ₹{fmtINR(editOfferPrice)} + GST (18%): ₹{fmtINR(gstCalc(editOfferPrice).gst)} = Total: ₹{fmtINR(gstCalc(editOfferPrice).total)}
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="sub-form-group">
                <label className="sub-form-label">Original Price</label>
                <input
                  type="number"
                  className="sub-form-control"
                  value={editOriginalPrice}
                  onChange={(e) => setEditOriginalPrice(e.target.value)}
                />
              </div>
              <div className="sub-form-row">
                <div className="sub-form-group">
                  <label className="sub-form-label">User Type</label>
                  <select className="sub-form-control" value={selectedPlan?.user_type || 'agent'} disabled>
                    <option value="agent">Agent</option>
                    <option value="agency">Agency</option>
                    <option value="builder">Builder</option>
                  </select>
                </div>
                <div className="sub-form-group">
                  <label className="sub-form-label">Billing Period</label>
                  <select className="sub-form-control" value={selectedPlan?.period || 'monthly'} disabled>
                    <option value="monthly">Monthly</option>
                    <option value="yearly">Yearly</option>
                  </select>
                </div>
              </div>
              <div className="sub-form-group">
                <label className="sub-form-label">Sub Features</label>
                {editSubFeatures.map((feature, index) => (
                  <div key={index} className="sub-feature-row">
                    <input
                      type="text"
                      className="sub-form-control"
                      value={feature.name || feature}
                      onChange={(e) => updateEditSubFeature(index, e.target.value)}
                      placeholder="Enter Feature"
                    />
                    <button type="button" className="sub-delete-feature-btn" onClick={() => removeEditSubFeature(index)}>
                      <img src={deleteIcon} alt="delete" />
                    </button>
                  </div>
                ))}
                <div className="sub-feature-row">
                  <input
                    type="text"
                    className="sub-form-control"
                    value={editNewSubFeature}
                    onChange={(e) => setEditNewSubFeature(e.target.value)}
                    placeholder="Enter New Feature"
                  />
                  <button type="button" className="sub-add-feature-btn" onClick={addEditSubFeature}>
                    <span className="sub-plus-icon">+</span> Add
                  </button>
                </div>
              </div>
              <div className="sub-form-row">
                <div className="sub-form-group">
                  <label className="sub-form-label">Status</label>
                  <select className="sub-form-control" value={editStatus} onChange={(e) => setEditStatus(e.target.value)}>
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                    <option value="Pending">Pending</option>
                  </select>
                </div>
                <div className="sub-form-group">
                  <label className="sub-form-label">Plan Label (Optional)</label>
                  <select className="sub-form-control" value={editPlanLabel} onChange={(e) => setEditPlanLabel(e.target.value)}>
                    <option value="">None</option>
                    <option value="Popular">Popular</option>
                    <option value="Most Popular">Most Popular</option>
                    <option value="Best Value">Best Value</option>
                    <option value="Recommended">Recommended</option>
                  </select>
                </div>
              </div>
              <div className="sub-form-group">
                <label className="sub-form-label">Save up to (Optional)</label>
                <input
                  type="text"
                  className="sub-form-control"
                  placeholder="E.g. 17%"
                  value={editSaveUpTo}
                  readOnly
                />
              </div>
              {/* Free Credits — only for builder + subscription_package (matching mobile app) */}
              {selectedPlan?.user_type === 'builder' && selectedPlan?.package_type === 'subscription_package' && (
                <div className="sub-form-group">
                  <label className="sub-form-label">Free Credits</label>
                  <input
                    type="number"
                    className="sub-form-control"
                    placeholder="Enter free credits"
                    value={editFreeCredits}
                    onChange={(e) => setEditFreeCredits(e.target.value)}
                    min="0"
                  />
                </div>
              )}
            </div>
            <div className="sub-modal-footer">
              <button className="sub-btn-secondary" onClick={() => {
                clearEditForm();
                setShowEditPlanModal(false);
              }}>Cancel</button>
              <button className="sub-btn-primary" onClick={updateSubscriptionPlan}>Save Changes</button>
            </div>
          </div>
        </div>
      )}

      {/* Edit Free Plan Modal */}
      {showEditFreePlanModal && (
        <div className="sub-modal-overlay" onClick={() => setShowEditFreePlanModal(false)}>
          <div className="sub-modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="sub-modal-header">
              <h3 className="sub-modal-title">Edit Plan</h3>
              <button style={{border:"none",background:"#fff"}} onClick={() => setShowEditFreePlanModal(false)}><img src={close} alt="Close" /></button>
            </div>
            <div className="sub-modal-body">
              <div className="sub-form-group">
                <label className="sub-form-label">Package Name</label>
                <input
                  type="text"
                  className="sub-form-control"
                  value={editPkgName}
                  onChange={(e) => setEditPkgName(e.target.value)}
                />
              </div>
              <div className="sub-form-group">
                <label className="sub-form-label">Package Description</label>
                <input
                  type="text"
                  className="sub-form-control"
                  value={editPkgFeature}
                  onChange={(e) => setEditPkgFeature(e.target.value)}
                />
              </div>
              <div className="sub-form-row">
                <div className="sub-form-group">
                  <label className="sub-form-label">User Type</label>
                  <select className="sub-form-control" value={selectedPlan?.user_type || 'agent'} disabled>
                    <option value="agent">Agent</option>
                    <option value="agency">Agency</option>
                    <option value="builder">Builder</option>
                  </select>
                </div>
                <div className="sub-form-group">
                  <label className="sub-form-label">Billing Period</label>
                  <select className="sub-form-control" value={selectedPlan?.period || 'monthly'} disabled>
                    <option value="monthly">Monthly</option>
                    <option value="yearly">Yearly</option>
                  </select>
                </div>
              </div>
              <div className="sub-form-group">
                <label className="sub-form-label">Sub Features</label>
                {editSubFeatures.map((feature, index) => (
                  <div key={index} className="sub-feature-row">
                    <input
                      type="text"
                      className="sub-form-control"
                      value={feature.name || feature}
                      onChange={(e) => updateEditSubFeature(index, e.target.value)}
                      placeholder="Enter Feature"
                    />
                    <button type="button" className="sub-delete-feature-btn" onClick={() => removeEditSubFeature(index)}>
                      <img src={deleteIcon} alt="delete" />
                    </button>
                  </div>
                ))}
                <div className="sub-feature-row">
                  <input
                    type="text"
                    className="sub-form-control"
                    value={editNewSubFeature}
                    onChange={(e) => setEditNewSubFeature(e.target.value)}
                    placeholder="Enter New Feature"
                  />
                  <button type="button" className="sub-add-feature-btn" onClick={addEditSubFeature}>
                    <span className="sub-plus-icon">+</span> Add
                  </button>
                </div>
              </div>
              <div className="sub-form-group">
                <label className="sub-form-label">Status</label>
                <select className="sub-form-control" value={editStatus} onChange={(e) => setEditStatus(e.target.value)}>
                  <option value="Active">Active</option>
                  <option value="Inactive">Inactive</option>
                  <option value="Pending">Pending</option>
                </select>
              </div>
              {/* Free Credits — only for builder + subscription_package (matching mobile app) */}
              {selectedPlan?.user_type === 'builder' && selectedPlan?.package_type === 'subscription_package' && (
                <div className="sub-form-group">
                  <label className="sub-form-label">Free Credits</label>
                  <input
                    type="number"
                    className="sub-form-control"
                    placeholder="Enter free credits"
                    value={editFreeCredits}
                    onChange={(e) => setEditFreeCredits(e.target.value)}
                    min="0"
                  />
                </div>
              )}
            </div>
            <div className="sub-modal-footer">
              <button className="sub-btn-secondary" onClick={() => {
                clearEditForm();
                setShowEditFreePlanModal(false);
              }}>Cancel</button>
              <button className="sub-btn-primary" onClick={updateSubscriptionPlan}>Save Changes</button>
            </div>
          </div>
        </div>
      )}

      {/* Add Push Notifications Credits Modal */}
      {showAddCreditModal && (
        <div className="sub-modal-overlay" onClick={() => setShowAddCreditModal(false)}>
          <div className="sub-modal-content sub-modal-small" onClick={(e) => e.stopPropagation()}>
            <div className="sub-modal-header">
              <h3 className="sub-modal-title">Add Plan</h3>
              <button style={{border:"none",background:"#fff"}} onClick={() => setShowAddCreditModal(false)}><img src={close} alt="Close" /></button>
            </div>
            <div className="sub-modal-body">
              <div className="sub-form-group">
                <label className="sub-form-label">Credits</label>
                <input
                  type="number"
                  className="sub-form-control"
                  placeholder="Enter Credits"
                  value={creditAmount}
                  onChange={(e) => {
                    setCreditAmount(e.target.value);
                    // Auto-calculate price based on master price
                    const calculatedPrice = parseInt(e.target.value || 0) * masterCreditPrice;
                    setCreditPrice(calculatedPrice.toString());
                  }}
                />
              </div>
              <div className="sub-form-group">
                <label className="sub-form-label">Credits Description</label>
                <input
                  type="text"
                  className="sub-form-control"
                  placeholder="Enter Description (e.g., For Small Campaigns)"
                  value={creditDescription}
                  onChange={(e) => setCreditDescription(e.target.value)}
                />
              </div>
              <div className="sub-form-group">
                <label className="sub-form-label">Credits Price</label>
                <input
                  type="number"
                  className="sub-form-control"
                  placeholder="Enter Credits Price"
                  value={creditPrice}
                  onChange={(e) => setCreditPrice(e.target.value)}
                />
                <small className="text-muted">Master rate: ₹{masterCreditPrice} per credit</small>
              </div>
              <div className="sub-form-group">
                <label className="sub-form-label">Status</label>
                <select className="sub-form-control" value={creditStatus} onChange={(e) => setCreditStatus(e.target.value)}>
                  <option value="active">Active</option>
                  <option value="inactive">Inactive</option>
                </select>
              </div>
            </div>
            <div className="sub-modal-footer">
              <button className="sub-btn-secondary" onClick={() => {
                clearCreditForm();
                setShowAddCreditModal(false);
              }}>Cancel</button>
              <button className="sub-btn-primary" onClick={createCreditPackage}>Create Package</button>
            </div>
          </div>
        </div>
      )}

      {/* Edit Push Notifications Credits Modal */}
      {showEditCreditModal && (
        <div className="sub-modal-overlay" onClick={() => setShowEditCreditModal(false)}>
          <div className="sub-modal-content sub-modal-small" onClick={(e) => e.stopPropagation()}>
            <div className="sub-modal-header">
              <h3 className="sub-modal-title">Edit Plan</h3>
              <button style={{border:"none",background:"#fff"}} onClick={() => setShowEditCreditModal(false)}><img src={close} alt="Close" /></button>
            </div>
            <div className="sub-modal-body">
              <div className="sub-form-group">
                <label className="sub-form-label">Credits</label>
                <input
                  type="number"
                  className="sub-form-control"
                  value={creditAmount}
                  onChange={(e) => {
                    setCreditAmount(e.target.value);
                    // Auto-calculate price based on master price
                    const calculatedPrice = parseInt(e.target.value || 0) * masterCreditPrice;
                    setCreditPrice(calculatedPrice.toString());
                  }}
                />
                <div className="sub-credit-note">1 Credit = ₹{masterCreditPrice}</div>
              </div>
              <div className="sub-form-group">
                <label className="sub-form-label">Credits Description</label>
                <input
                  type="text"
                  className="sub-form-control"
                  value={creditDescription}
                  onChange={(e) => setCreditDescription(e.target.value)}
                />
              </div>
              <div className="sub-form-group">
                <label className="sub-form-label">Credits Price</label>
                <input
                  type="number"
                  className="sub-form-control"
                  value={creditPrice}
                  onChange={(e) => setCreditPrice(e.target.value)}
                />
              </div>
              <div className="sub-form-group">
                <label className="sub-form-label">Status</label>
                <select className="sub-form-control" value={creditStatus} onChange={(e) => setCreditStatus(e.target.value)}>
                  <option value="active">Active</option>
                  <option value="inactive">Inactive</option>
                </select>
              </div>
            </div>
            <div className="sub-modal-footer">
              <button className="sub-btn-secondary" onClick={() => {
                clearCreditForm();
                setShowEditCreditModal(false);
              }}>Cancel</button>
              <button className="sub-btn-primary" onClick={updateCreditPackage}>Save Changes</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
